import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { Field } from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { Select as MuiSelect } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import useStyles from "assets/jss/material-dashboard-react/components/customSelectStyle";
import ErrorMessage from "@Components/ErrorMessage";

const Select = (props) => {
  const { t } = useTranslation();
  const { label, required, name, options, errorMessage, ...rest } = props;
  const classes = useStyles();

  return (
    <Field name={name}>
      {(props) => {
        const { field, meta } = props;
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classes.label, {
                [classes.error]: errorMessage || (meta.error && meta.touched),
              })}
            >
              {t(label)}
              {required ? <span style={{ color: "red" }}> *</span> : null}
            </InputLabel>
            <FormControl variant="outlined" fullWidth size="small">
              <MuiSelect
                value={field.value}
                autoWidth
                error={Boolean(meta.touched) && Boolean(meta.error)}
                displayEmpty
                {...field}
                {...rest}
              >
                <MenuItem disabled value="">
                  {t("Select ") + t(label)}
                </MenuItem>
                {options.map((option, index) => {
                  return (
                    <MenuItem key={index} value={option.id}>
                      {option.name}
                    </MenuItem>
                  );
                })}
              </MuiSelect>
            </FormControl>
            <ErrorMessage message={errorMessage ? errorMessage : meta.error} />
          </>
        );
      }}
    </Field>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  options: PropTypes.array,
  field: PropTypes.object,
  meta: PropTypes.object,
  errorMessage: PropTypes.array,
};

export default Select;
